"use strict";
// <copyright file="pagination.tsx" company="Microsoft">
// Copyright (c) Microsoft. All rights reserved.
// </copyright>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var icons_1 = require("@uifabric/icons");
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        icons_1.initializeIcons();
        return _this;
    }
    ;
    Pagination.prototype.render = function () {
        var _this = this;
        var numberOfPages = Math.ceil(this.props.entitiesLength / this.props.numberOfContents);
        var createPagination = function (params) {
            var currentPage = params.currentPage, numberOfButtons = params.numberOfButtons;
            if ((currentPage - 1) > numberOfPages || currentPage < 1)
                return {
                    pagination: [],
                    currentPage: currentPage
                };
            var buttons = Array(numberOfPages)
                .fill(1)
                .map(function (e, i) { return e + i; });
            var sideButtons = numberOfButtons % 2 === 0 ? numberOfButtons / 2 : (numberOfButtons - 1) / 2;
            var calculLeft = function (rest) {
                if (rest === void 0) { rest = 0; }
                return {
                    array: buttons
                        .slice(0, currentPage - 1)
                        .reverse()
                        .slice(0, sideButtons + rest)
                        .reverse(),
                    rest: function () {
                        return sideButtons - this.array.length;
                    }
                };
            };
            var calculRight = function (rest) {
                if (rest === void 0) { rest = 0; }
                return {
                    array: buttons.slice(currentPage).slice(0, sideButtons + rest),
                    rest: function () {
                        return sideButtons - this.array.length;
                    }
                };
            };
            var leftButtons = calculLeft(calculRight().rest()).array;
            var rightButtons = calculRight(calculLeft().rest()).array;
            return {
                pagination: __spreadArrays(leftButtons, [currentPage], rightButtons),
                currentPage: currentPage
            };
        };
        var pagination = createPagination({
            numberOfContents: this.props.entitiesLength,
            numberOfButtons: 8,
            currentPage: (this.props.activePage + 1)
        }).pagination;
        var paginationRender = pagination.map(function (page, index) {
            return ((_this.props.activePage + 1) == page ?
                React.createElement("div", { key: index },
                    React.createElement(react_northstar_1.Button, { content: page, onClick: function () { return _this.props.callbackFromParent((page - 1)); }, primary: true, styles: { border: 'none', boxShadow: 'none' }, iconOnly: true }))
                :
                    React.createElement("div", { key: index },
                        React.createElement(react_northstar_1.Button, { content: page, onClick: function () { return _this.props.callbackFromParent((page - 1)); }, secondary: true, styles: { border: 'none', boxShadow: 'none' }, iconOnly: true })));
        });
        return (React.createElement(react_northstar_1.FlexItem, null,
            React.createElement(React.Fragment, null,
                React.createElement(react_northstar_1.Button, { content: React.createElement(react_icons_northstar_1.ChevronStartIcon, null), onClick: function () { return _this.props.callbackFromParent(_this.props.activePage - 1); }, secondary: true, styles: { border: 'none', boxShadow: 'none' }, iconOnly: true, disabled: this.props.activePage == 0 }),
                paginationRender,
                React.createElement(react_northstar_1.Button, { content: React.createElement(react_icons_northstar_1.ChevronEndIcon, null), onClick: function () { return _this.props.callbackFromParent(_this.props.activePage + 1); }, secondary: true, styles: { border: 'none', boxShadow: 'none' }, iconOnly: true, disabled: (this.props.activePage + 1) == numberOfPages }))));
    };
    return Pagination;
}(React.Component));
exports.default = Pagination;
//# sourceMappingURL=pagination.js.map